var _rect, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _path4, _path5, _path6, _path7, _path8, _ellipse4, _path9, _circle, _path10, _path11, _path12, _g, _g2, _g3, _path13, _path14, _path15, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1220,
    height: 335,
    viewBox: "0 0 1220 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2864_827)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 495,
    y: 50,
    width: 230,
    height: 230,
    rx: 115,
    fill: "#161616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M654.285 124.325L637.663 106.449H618.008",
    stroke: "#9AD2FF",
    strokeWidth: 1.42278
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M642.209 138.79V125.135L632.951 116.25H612.084L600.469 127.865",
    stroke: "#9AD2FF",
    strokeWidth: 1.42278
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M632.646 146.248V126.36L622.994 126.359",
    stroke: "#9AD2FF",
    strokeWidth: 1.42278
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.838,
    cy: 106.41,
    rx: 3.37907,
    ry: 3.37915,
    fill: "#161616",
    stroke: "url(#paint0_linear_2864_827)",
    strokeWidth: 1.42278
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 599.69,
    cy: 128.117,
    rx: 3.37907,
    ry: 3.37915,
    fill: "#161616",
    stroke: "url(#paint1_linear_2864_827)",
    strokeWidth: 1.42278
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 621.387,
    cy: 126.336,
    rx: 3.37907,
    ry: 3.37915,
    fill: "#161616",
    stroke: "url(#paint2_linear_2864_827)",
    strokeWidth: 1.42278
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M606.883 166.25C600.518 164.247 596.177 159.741 590.501 155.163C586.023 150.217 582.767 144.641 581.404 138.109C580.042 131.578 580.445 124.801 582.572 118.476C584.699 112.152 588.474 106.509 593.507 102.129C598.54 97.7481 604.649 94.7883 611.206 93.554C617.763 92.3198 624.531 92.8557 630.812 95.1066C637.093 97.3574 642.661 101.242 646.942 106.36C651.223 111.478 653.848 117.638 654.954 124.218",
    stroke: "#9AD2FF",
    strokeWidth: 1.90715
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M610.711 146.512V173.76C610.231 173.542 609.77 173.283 609.334 172.986C604.005 168.474 598.702 163.932 593.369 159.415C587.021 154.017 582.612 146.692 580.812 138.555C579.012 130.419 579.921 121.918 583.4 114.345C590.769 98.521 607.405 89.6721 624.457 92.5333C632.109 93.7695 639.2 97.3151 644.78 102.695C650.36 108.075 654.162 115.032 655.677 122.634C656.058 124.486 655.934 126.453 655.942 128.365C655.942 133.639 655.912 138.916 655.908 144.19C655.908 144.959 655.972 145.729 656.024 146.858H661.883C665.8 146.858 669.722 146.858 673.644 146.82C674.828 146.82 675.32 147.248 675.273 148.445C675.15 150.439 675.131 152.437 675.218 154.433C675.324 156.037 674.85 156.52 673.216 156.486C668.229 156.379 663.238 156.443 658.247 156.447C657.555 156.447 656.862 156.511 656.049 156.55C656.011 157.311 655.947 157.936 655.942 158.56C655.917 179.517 655.942 196.811 655.831 217.768C655.831 219.791 656.297 220.497 658.397 220.441C663.794 220.296 669.196 220.39 675.243 220.39C673.994 221.386 673.212 222.019 672.416 222.635C668.593 225.629 664.855 228.704 660.929 231.535C654.163 236.42 646.773 237.16 639.319 233.537C631.864 229.914 627.771 223.662 627.532 215.322C627.284 206.704 627.416 201.735 627.412 193.109C627.412 177.926 627.438 162.743 627.412 147.556C627.366 146.966 627.475 146.374 627.729 145.84C627.982 145.306 628.371 144.847 628.858 144.51C637.174 138.027 645.443 131.482 653.663 124.875C654.21 124.447 654.544 123.254 654.411 122.523C651.161 104.402 632.54 90.9166 614.21 93.3502C597.047 95.6255 584.602 107.203 581.574 123.96C580.269 131.096 581.177 138.46 584.174 145.066C584.486 145.772 585.748 146.456 586.582 146.465C593.921 146.563 601.264 146.508 608.607 146.499L610.711 146.512Z",
    fill: "url(#paint3_linear_2864_827)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M572.282 221.325C572.249 225.139 570.704 228.784 567.985 231.46C565.267 234.136 561.598 235.624 557.783 235.597C549.854 235.528 543.623 229.07 543.67 220.982C543.726 213.331 550.462 206.646 557.912 206.869C565.999 207.065 572.389 213.506 572.282 221.325Z",
    fill: "#9AD2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2864_827",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 579,
    y: 92,
    width: 97,
    height: 144
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M610.711 146.512V173.76C610.231 173.542 609.77 173.283 609.334 172.986C604.005 168.474 598.702 163.932 593.369 159.415C587.021 154.017 582.612 146.692 580.812 138.555C579.012 130.419 579.921 121.918 583.4 114.345C590.769 98.521 607.405 89.6721 624.457 92.5333C632.109 93.7695 639.2 97.3151 644.78 102.695C650.36 108.075 654.162 115.032 655.677 122.634C656.058 124.486 655.934 126.453 655.942 128.365C655.942 133.639 655.912 138.916 655.908 144.19C655.908 144.959 655.972 145.729 656.024 146.858H661.883C665.8 146.858 669.722 146.858 673.644 146.82C674.828 146.82 675.32 147.248 675.273 148.445C675.15 150.439 675.131 152.437 675.218 154.433C675.324 156.037 674.85 156.52 673.216 156.486C668.229 156.379 663.238 156.443 658.247 156.447C657.555 156.447 656.862 156.511 656.049 156.55C656.011 157.311 655.947 157.936 655.942 158.56C655.917 179.517 655.942 196.811 655.831 217.768C655.831 219.791 656.297 220.497 658.397 220.441C663.794 220.296 669.196 220.39 675.243 220.39C673.994 221.386 673.212 222.019 672.416 222.635C668.593 225.629 664.855 228.704 660.929 231.535C654.163 236.42 646.773 237.16 639.319 233.537C631.864 229.914 627.771 223.662 627.532 215.322C627.284 206.704 627.416 201.735 627.412 193.109C627.412 177.926 627.438 162.743 627.412 147.556C627.366 146.966 627.475 146.374 627.729 145.84C627.982 145.306 628.371 144.847 628.858 144.51C637.174 138.027 645.443 131.482 653.663 124.875C654.21 124.447 654.544 123.254 654.411 122.523C651.161 104.402 632.54 90.9166 614.21 93.3502C597.047 95.6255 584.602 107.203 581.574 123.96C580.269 131.096 581.177 138.46 584.174 145.066C584.486 145.772 585.748 146.456 586.582 146.465C593.921 146.563 601.264 146.508 608.607 146.499L610.711 146.512Z",
    fill: "#584EF3"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2864_827)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M655.919 123.221C654.55 124.248 653.78 124.789 653.566 124.932L634.107 126.215C630.543 131.276 623.33 141.868 622.988 143.75C622.56 146.103 615.717 176.896 613.793 182.456C612.253 186.904 587.205 159.646 574.874 145.461L568.887 96.4907C571.31 92.4276 578.124 83.6171 585.994 80.8799C595.83 77.4584 609.302 84.3014 621.705 84.3014C634.107 84.3014 673.881 98.2013 676.447 99.2705C678.5 100.126 663.617 115.594 655.919 123.221Z",
    fill: "#9AD2FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_2864_827)",
    style: {
      mixBlendMode: "overlay"
    }
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 605.732,
    cy: 173.413,
    rx: 19.7752,
    ry: 19.7758,
    fill: "#161616"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M567.313 144.268C566.009 145.422 564.435 146.406 563.443 147.77C560.62 151.688 561.304 156.243 565.175 159.587C571.064 164.656 577.051 169.574 583 174.561C590.271 180.651 597.644 186.587 604.701 192.892C612.146 199.546 614.704 208.07 612.095 217.698C609.379 227.718 602.592 233.787 592.388 235.943C592 236.004 591.609 236.044 591.216 236.062C592.426 234.993 593.872 234.069 594.843 232.782C597.939 228.693 597.46 224.143 593.56 220.807C587.401 215.521 581.157 210.354 574.917 205.128C568.07 199.367 561.138 193.636 554.338 187.781C540.4 175.78 543.748 153.437 560.59 146.008C562.703 145.076 565.021 144.614 567.241 143.93L567.313 144.268Z",
    fill: "url(#paint4_linear_2864_827)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 165,
    r: 108.5,
    stroke: "#229CFF",
    strokeDasharray: "3 2"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135 5.5C209.193 5.5 269.5 79.0507 269.5 170C269.5 260.949 209.193 334.5 135 334.5C60.8068 334.5 0.5 260.949 0.5 170C0.5 79.0507 60.8068 5.5 135 5.5Z",
    stroke: "url(#paint5_linear_2864_827)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M260 28.5C325.922 28.5 379.5 91.7695 379.5 170C379.5 248.23 325.922 311.5 260 311.5C194.078 311.5 140.5 248.23 140.5 170C140.5 91.7695 194.078 28.5 260 28.5Z",
    stroke: "url(#paint6_linear_2864_827)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M375 45.5C432.636 45.5 479.5 101.155 479.5 170C479.5 238.845 432.636 294.5 375 294.5C317.364 294.5 270.5 238.845 270.5 170C270.5 101.155 317.364 45.5 375 45.5Z",
    stroke: "url(#paint7_linear_2864_827)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2864_827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 427,
    cy: 62,
    r: 4,
    fill: "#229CFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2864_827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 103.5,
    r: 4.5,
    fill: "#229CFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2864_827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 291,
    r: 5,
    fill: "#229CFF"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1085 5.5C1010.81 5.5 950.5 79.0507 950.5 170C950.5 260.949 1010.81 334.5 1085 334.5C1159.19 334.5 1219.5 260.949 1219.5 170C1219.5 79.0507 1159.19 5.5 1085 5.5Z",
    stroke: "url(#paint8_linear_2864_827)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M960 28.5C894.078 28.5 840.5 91.7695 840.5 170C840.5 248.23 894.078 311.5 960 311.5C1025.92 311.5 1079.5 248.23 1079.5 170C1079.5 91.7695 1025.92 28.5 960 28.5Z",
    stroke: "url(#paint9_linear_2864_827)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M845 45.5C787.364 45.5 740.5 101.155 740.5 170C740.5 238.845 787.364 294.5 845 294.5C902.636 294.5 949.5 238.845 949.5 170C949.5 101.155 902.636 45.5 845 45.5Z",
    stroke: "url(#paint10_linear_2864_827)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2864_827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(-1 0 0 1 797 58)",
    fill: "#229CFF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2864_827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 1070 99)",
    fill: "#229CFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_2864_827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(-1 0 0 1 1181 286)",
    fill: "#229CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2864_827",
    x: 445,
    y: 0,
    width: 330,
    height: 330,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.611765 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2864_827"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2864_827",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2864_827",
    x: 559.257,
    y: 126.937,
    width: 92.9509,
    height: 92.9509,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.35,
    result: "effect1_foregroundBlur_2864_827"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2864_827",
    x: 418,
    y: 53,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2864_827"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2864_827",
    x: 145,
    y: 94,
    width: 19,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2864_827"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2864_827",
    x: 34,
    y: 281,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2864_827"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2864_827",
    x: 784,
    y: 53,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2864_827"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2864_827",
    x: 1056,
    y: 94,
    width: 19,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2864_827"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2864_827",
    x: 1166,
    y: 281,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2864_827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2864_827",
    x1: 617.844,
    y1: 102.316,
    x2: 617.844,
    y2: 110.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED953C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2864_827",
    x1: 599.696,
    y1: 124.023,
    x2: 599.696,
    y2: 132.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED953C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2864_827",
    x1: 621.393,
    y1: 122.242,
    x2: 621.393,
    y2: 130.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED953C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2864_827",
    x1: 627.614,
    y1: 181.281,
    x2: 667.629,
    y2: 181.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4259F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A47F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2864_827",
    x1: 555.591,
    y1: 190.173,
    x2: 613.035,
    y2: 213.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E62FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2864_827",
    x1: 238.5,
    y1: 170,
    x2: 0.00000400307,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229CFF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2864_827",
    x1: 380,
    y1: 170,
    x2: 140,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229CFF",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2864_827",
    x1: 480,
    y1: 170,
    x2: 270,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229CFF",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2864_827",
    x1: 981.5,
    y1: 170,
    x2: 1220,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229CFF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2864_827",
    x1: 840,
    y1: 170,
    x2: 1080,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229CFF",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2864_827",
    x1: 740,
    y1: 170,
    x2: 950,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229CFF",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutus);
export default __webpack_public_path__ + "static/media/aboutus.0d98c7cee2ada2e96d2f4f1c4732438b.svg";
export { ForwardRef as ReactComponent };